<template>
  <v-row class="mb-auto" justify="center">
    <v-col cols="12">
      <search v-if="issearch" :items="headers" @querydata="querydata"></search>
      <v-data-table show-select @toggle-select-all="selectAll" :multi-sort="false" v-model="selected" item-key="Id"
        :headers="headers" :items="mainData" :items-per-page="limit" :options.sync="options"
        :server-items-length="countData" :loading="loading" class="elevation-1 text-no-wrap" show-group-by
        :footer-props="{ itemsPerPageText: '分页:', 'items-per-page-options':[10,20,30,50,100,-1] }">
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title>菜单</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-btn small :color="issearch ? 'error' : 'success'" dark class="mr-2" @click="issearch = !issearch">
              <v-icon>{{issearch ? "mdi-magnify-close" : "mdi-magnify"}}</v-icon>
            </v-btn>
            <v-btn small color="warning" dark @click="delselect">
              删除 <v-icon>mdi-checkbox-marked-outline</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="600px">
              <template v-slot:activator="{ on, attrs }">
                <v-btn small color="primary" dark v-bind="attrs" v-on="on">新增</v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-form ref="form">
                      <v-row>
                        <v-col cols="12" sm="6" md="4">
                          <v-autocomplete v-model="editedItem.Pid" :items="mainData" item-text="Title" item-value="Id"
                            clearable label="上级菜单"></v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <v-text-field :rules="[(v) => !!v || '必填项']" v-model.trim="editedItem.Title" label="标题">
                          </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <v-text-field v-model.trim="editedItem.Url" label="URL">
                          </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <v-text-field v-model.trim="editedItem.Icon" label="图标">
                          </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <v-text-field v-model.number="editedItem.Sort" label="排序">
                          </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <v-autocomplete v-model="editedItem.Roleid" :items="roles" item-text="RoleName"
                            item-value="Id" clearable label="所属角色"></v-autocomplete>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="close">取消</v-btn>
                  <v-btn color="blue darken-1" :loading="loading" text @click="save">保存</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>

        <template v-slot:item.actions="{ item }">
          <v-icon color="info" class="mr-4" @click="editItem(item)">mdi-pencil</v-icon>
          <v-icon color="error" @click="deleteItem(item)">mdi-delete</v-icon>
        </template>
        <template v-slot:no-data>
          <v-btn color="primary" @click="initialize">刷新数据</v-btn>
        </template>
      </v-data-table>
    </v-col>
  </v-row>
</template>

<script>
  import search from "@/components/search";
  export default {
    components: {
      search,
    },
    data: function () {
      return {
        dialog: false,
        selected: [],
        headers: [
          { text: "ID", value: "Id", groupable: false },
          { text: "上级菜单", value: "Pid" },
          { text: "标题", value: "Title", groupable: false },
          { text: "Url", value: "Url", groupable: false },
          { text: "Icon", value: "Icon", groupable: false },
          { text: "排序", value: "Sort", groupable: false },
          { text: "角色", value: "Roleid" },
          {
            text: "操作",
            value: "actions",
            sortable: false,
            groupable: false
          },
        ],
        issearch: false,
        mainData: [],
        countData: 0,
        offset: 0,
        limit: this.$store.state.glimit,
        query: "",
        exclude: "",
        sortby: "",
        order: "",
        options: {},
        loading: false,
        editedIndex: -1,
        editedItem: {
          Sort: 0,
          Pid: 0,
          Roleid: 0,
        },
        defaultItem: {
          Sort: 0,
          Pid: 0,
          Roleid: 0,
        },
        roles: [],
      }
    },
    computed: {
      formTitle() {
        return this.editedIndex === -1 ? "新增" : "编辑";
      },
    },
    watch: {
      dialog(val) {
        val || this.close();
      },
      options: {
        handler() {
          this.limit = this.options.itemsPerPage;
          this.offset = (this.options.page - 1) * this.limit;
          this.sortby = "";
          this.order = "";
          for (let index = 0; index < this.options.sortBy.length; index++) {
            this.sortby += this.options.sortBy[index] + ",";
            this.order += this.options.sortDesc[index] ? "desc," : "asc,";
          }
          if (this.sortby.length > 0) {
            this.sortby = this.sortby.slice(0, -1);
            this.order = this.order.slice(0, -1);
          } else {
            this.sortby = "Id";
            this.order = "desc";
          }
          this.initialize();
        },
        deep: true,
      },
    },
    methods: {
      querydata(query, exclude) {
        this.query = query;
        this.exclude = exclude;
        this.initialize();
      },
      selectAll(item) {
        this.selected = item.value ? item.items : [];
      },
      delselect(e) {
        if (!confirm("确认删除所有选中项吗?")) return;
        if (this.selected.length > 0) {
          let ids = "";
          let arrid = [];
          for (let index = 0; index < this.selected.length; index++) {
            ids += this.selected[index].Id + ",";
            arrid.push(this.selected[index].Id);
          }
          if (ids.length > 0) {
            ids = ids.slice(0, -1);
          }
          this.loading = true;
          this.$api.delMenu({
            id: ids
          }).then((res) => {
            this.loading = false;
            for (let index = 0; index < arrid.length; index++) {
              this.mainData = this.mainData.filter(
                (item) => item.Id != arrid[index]
              );
            }
            this.countData -= arrid.length;
          }).catch((error) => {
            this.loading = false;
            let message = (error && error.msg) || "删除选中选失败！";
            this.$store.commit("setsnack", { message });
            console.error(error);
          });
        } else {
          this.$store.commit("setsnack", { message: "尚未选择任何项目",  color: "warning" });
        }
      },
      initialize() {
        this.loading = true;
        let data = {
          limit: this.limit,
          offset: this.offset,
        };
        if (this.query != "") {
          data.query = this.query;
        }
        if (this.exclude != "") {
          data.exclude = this.exclude;
        }
        if (this.sortby != "") {
          data.sortby = this.sortby;
          data.order = this.order;
        }
        this.$api.getMenus(data).then((res) => {
          this.loading = false;
          if (res.data) {
            this.mainData = res.data;
            this.countData = res.count;
          } else {
            this.mainData = [];
            this.countData = 0;
          }
        }).catch((error) => {
          this.loading = false;
          let message = (error && error.msg) || "获取数据列表失败！";
          this.$store.commit("setsnack", { message });
          console.error(error);
        });
        this.$api.getRoles({
          limit: -1,
          fields: "Id,RoleName",
        }).then((res) => {
          this.loading = false;
          this.roles = res.data;
        }).catch((error) => {
          this.loading = false;
          this.$store.commit("setsnack", { message: "获取角色列表失败！" });
          console.error(error);
        });
      },
      editItem(item) {
        this.editedIndex = this.mainData.indexOf(item);
        this.editedItem = Object.assign({}, item);
        this.dialog = true;
      },
      deleteItem(item) {
        const index = this.mainData.indexOf(item);
        if (confirm("确认删除此项数据吗?")) {
          // Del Item
          const data = {
            id: item.Id,
          };
          this.loading = true;
          this.$api.delMenu(data).then((res) => {
            this.loading = false;
            this.mainData.splice(index, 1);
            this.countData--;
          }).catch((error) => {
            this.loading = false;
            let message = (error && error.msg) || "删除失败！";
            this.$store.commit("setsnack", { message });
            console.error(error);
          });
        }
      },
      close() {
        this.dialog = false;
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.editedIndex = -1;
        });
      },
      save() {
        if (!this.$refs.form.validate()) return;
        this.editedItem.Sort = parseInt(this.editedItem.Sort) || 0
        this.editedItem.Pid = parseInt(this.editedItem.Pid) || 0
        this.editedItem.Roleid = parseInt(this.editedItem.Roleid) || 0
        let data = JSON.parse(JSON.stringify(this.editedItem));
        this.loading = true;
        if (this.editedIndex > -1) {
          //Edit Item
          this.$api.editMenu(data).then((res) => {
            this.loading = false;
            Object.assign(this.mainData[this.editedIndex], this.editedItem);
            this.close();
          }).catch((error) => {
            this.loading = false;
            let message = (error && error.msg) || "编辑失败！";
            this.$store.commit("setsnack", { message });
            console.error(error);
          });
        } else {
          this.$api.addMenu(data).then((res) => {
            this.loading = false;
            this.editedItem.Id = res.data;
            this.mainData.unshift(this.editedItem);
            this.countData++;
            this.close();
          }).catch((error) => {
            this.loading = false;
            let message = (error && error.msg) || "添加失败！";
            this.$store.commit("setsnack", { message });
            console.error(error);
          });
        }
      },
    },
  };
</script>